import { useMutation } from "@tanstack/react-query";
import { formsService } from "../../services/formsService";

// Mutation keys
export const formMutationKeys = {
  create: "createForm",
  update: "updateForm",
  updateFields: "updateFormFields",
  updateWithFields: "updateFormWithFields",
  deleteForm: "deleteForm",
};

// Create a new form
export const useCreateForm = (options) =>
  useMutation({
    mutationKey: formMutationKeys.create,
    mutationFn: (formData) => formsService.createForm(formData),
    ...options,
  });

// Update a form
export const useUpdateForm = (options) =>
  useMutation({
    mutationKey: formMutationKeys.update,
    mutationFn: ({ formId, formData }) =>
      formsService.updateForm(formId, formData),
    ...options,
  });

// Update form fields
export const useUpdateFormFields = (options) =>
  useMutation({
    mutationKey: formMutationKeys.updateFields,
    mutationFn: (fieldData) => formsService.updateFormFields(fieldData),
    ...options,
  });

// Update form with fields
export const useUpdateFormWithFields = (options) =>
  useMutation({
    mutationKey: formMutationKeys.updateWithFields,
    mutationFn: (formId) => formsService.updateFormWithFields(formId),
    ...options,
  });

// Delete a form
export const useDeleteForm = (options) =>
  useMutation({
    mutationKey: formMutationKeys.deleteForm,
    mutationFn: (formId) => formsService.deleteForm(formId),
    ...options,
  });
